import { IvoLicense, Profile } from './types';

export function getProfileIvoLicenses(profile: Profile): IvoLicense[] {
  const company = profile.graphData?.nodes?.find((node: any) =>
    node.properties?.organization_number === profile.orgNumber,
  );
  const graphLicenses = company?.properties?.ivo_licenses;

  return (profile.licenses ?? []).map((license) => {
    // Older profile API responses omit activity even when the graph includes it.
    if (typeof license.active === 'boolean' || !Array.isArray(graphLicenses)) {
      return license;
    }
    const match = graphLicenses.find((item: any) =>
      item?.licence === license.licence && item?.since === license.since,
    );
    if (typeof match?.active !== 'boolean') return license;

    return {
      ...license,
      active: match.active,
      updated: match.updated ?? license.updated,
      firstSeen: match.first_seen ?? license.firstSeen,
      lastSeen: match.last_seen ?? license.lastSeen,
      inactiveSince: match.inactive_since ?? license.inactiveSince,
    };
  });
}
